import React from 'react';

const TotalRevenueGraph = () => {
  return (
    <div className="col-6">
      <h6>
        <b>Total Revenue</b>
      </h6>
      <small>Showing statistic of alll time</small>
      <div className="card o-income card-body">
        <div id="call-revenue" />
      </div>
    </div>
  );
};

export default TotalRevenueGraph;
